import React,{useState} from "react"
import EditButton from "./EditButton";
import Api from "./Api";
import { useGlobal } from "./Reducer";

const EXTENDED="EXTENDED";
const COLLASPTED="COLLASPTED";



export default (props)=>{

    const [mode,setMode]=useState(COLLASPTED);
    const [gs,ga]=useGlobal();

    const article=props.article||{};
    return (
    <React.Fragment>
        
        
    
    <div className="whitebg boxed featured_news" id="allfeaturedarea" ng-show="featured_and_key_topics" >
    <div className="changeable newsset" ref_tag="news_setter"
    style={{textAlign:"right",position:"absolute",right:5,zIndex:5}}
    >                  <div className="globaleditbtn  hvr-shrink" data-toggle="tooltip" data-placement="right" title="" data-original-title="Edit News Articles"><EditButton onClick={()=>{
        props.setShowEditor(true);
    }}/></div></div>
        
        
        <div className="col-xs-12" ref_tag="featured_setter"> <div className={"col-xs-12 "+(mode==COLLASPTED?" faded_article":"")}><span className="textblack featured_title"> {article.title}</span><br/><span style={{fontSize:10,fontStyle:"italic"}}>{article.byline}  </span><span> <p dangerouslySetInnerHTML={{__html:article.intro}}></p></span></div>
          {mode==EXTENDED &&  <div dangerouslySetInnerHTML={{__html:article.body}} style={{marginBottom:20}}>
               
            </div>}

        {mode==COLLASPTED && <div className="col-xs-12 text-center"><a href="#" className="patted learnmore  dpl_btn" onClick={(e)=>{
              event.preventDefault();
              Api.recordAnalytics(gs.appData.id,"MAIN_ARTICLE_OPEN",article.title,article.id);
              setMode(EXTENDED);

        }}>Read more</a> </div>}
         {mode==EXTENDED && <div className="col-xs-12"><a href="#" className="patted learnmore  dpl_btn" onClick={(e)=>{
              event.preventDefault();
              setMode(COLLASPTED);

        }}>Close</a> </div>}
        
        </div></div></React.Fragment>);
}